import { render, staticRenderFns } from "./Desempenho.vue?vue&type=template&id=2388157a&scoped=true"
import script from "./Desempenho.vue?vue&type=script&lang=js"
export * from "./Desempenho.vue?vue&type=script&lang=js"
import style0 from "./Desempenho.vue?vue&type=style&index=0&id=2388157a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388157a",
  null
  
)

export default component.exports